<template>
  <div
    :class="[fromCampaignPage ? 'campaign-image' : '']"
    :style="fromCampaignPage ? '' : 'height: 0'"
  >
    <!-- Deactivated org block — shown when login returns org_deactivated -->
    <CModal
      color="danger"
      :show.sync="showDeactivatedModal"
      :closeOnBackdrop="false"
      centered
    >
      <template #header>
        <div class="d-flex align-items-center">
          <i class="fa-solid fa-circle-xmark mr-2 text-white" style="font-size:1.1rem"></i>
          <h5 class="modal-title text-white mb-0">Organisation Account Deactivated</h5>
        </div>
      </template>
      <div class="px-3 py-3">
        <div class="deact-banner mb-3">
          <i class="fa-solid fa-triangle-exclamation mr-2"></i>
          Access to this organisation is no longer available.
        </div>
        <p style="font-size:0.9rem;color:#2c3e50" class="mb-3">
          The organisation account you are trying to access has been deactivated.
          You are not permitted to log in to this organisation.
        </p>
        <div v-if="orgDeactivated && orgDeactivated.primary_path_acronym" class="deact-primary-box mb-3">
          <i class="fa-solid fa-building-circle-check mr-2"></i>
          You can switch to your primary organisation to continue using TalentFind.
        </div>
        <div class="deact-support-box">
          <i class="fa-solid fa-headset mr-2"></i>
          If you believe this is an error or need to reactivate this organisation,
          please contact the TalentFind support team.
        </div>
      </div>
      <template #footer>
        <CButton
          v-if="orgDeactivated && orgDeactivated.primary_path_acronym"
          color="primary"
          @click="switchToPrimaryOrgLogin"
        >
          <i class="fa-solid fa-right-left mr-1"></i>
          Switch to Primary Organisation
        </CButton>
        <CButton v-else color="secondary" disabled>
          <i class="fa-solid fa-headset mr-1"></i> Contact Support
        </CButton>
      </template>
    </CModal>
    <img
      v-if="fromCampaignPage"
      id="bg-img"
      class="position-fixed d-none"
      :class="isTFW ? 'istfw' : ''"
      :src="getBackgroundImage"
      @error="
        $event.target.src = '/img/new_home_bg.png';
        $event.target.style = `width: ${getScreenSize.width}px; height: ${getScreenSize.height}px`;
      "
      alt="bg"
    />
    <div
      v-if="!showDeactivatedModal"
      class="registration container-md col-lg-8 col-md-8 p-3"
      :class="[
        fromCampaignPage && `${getScreenSize.width}` > 1084
          ? 'card p-4 campaign-register'
          : 'pt-3',
      ]"
      :style="{
        height: displayPage === 1 && fromCampaignPage ? 'max-content' : 'auto ',
      }"
    >
      <div class="d-flex flex-row justify-content-between">
        <div class="d-flex justify-content-between w-100">
          <h3
            class="pb-3 px-1 mb-0 main-title"
            :class="isTFW ? 'text-white font-weight-bold' : 'text-primary'"
          >
            {{
              displayPage == 2 || displayPage === 3
                ? "Registration"
                : displayPage === 5 || displayPage === 6
                ? ""
                : isCandidateSupplier
                ? "Add Candidate"
                : displayPage === 4
                ? "Registration"
                : ""
            }}
          </h3>
          <!-- <div v-if="displayPage === 4 && !getExistUserCandidate.full_registration">
            <button class="btn btn-primary mb-2" @click="$router.push('/home')">
              <i class="fa-solid fa-arrow-left"></i>&nbsp;Back
            </button>
          </div> -->
        </div>
      </div>
      <div
        v-if="displayPage == 1 && !isCandidateSupplier"
        class="mx-auto custom-container"
      >
        <CCard class="mt-2 shadow-lg">
          <CCardHeader
            v-if="isPartnerAgency" 
            :class="isTFW ? 'bg-tfw-brand text-white h3 rounded' 
              :'bg-primary text-white h3'"
          >
            Register
          </CCardHeader>
          <CCardHeader 
            v-else
            :class="isTFW ? 'bg-tfw-brand text-white h3 rounded' 
              :'bg-primary text-white h3'"
          >
            Register or Login
          </CCardHeader>
          <ul class="nav nav-tabs custom-tabs m-2" v-if="!isPartnerAgency">
            <li class="nav-item flex-grow-1 text-center">
              <a
                class="nav-link custom-tab"
                :class="{ active: activeTab === 'login' }"
                href="#"
                @click.prevent="activeTab = 'login'"
              >
                Login
              </a>
            </li>
            <li class="nav-item flex-grow-1 text-center">
              <a
                class="nav-link custom-tab"
                :class="{ active: activeTab === 'register' }"
                href="#"
                @click.prevent="activeTab = 'register'"
              >
                Register
              </a>
            </li>
          </ul>
          <CCardBody v-if="activeTab === 'login'">
            <div class="col-12">
                <ValidationObserver  ref="loginObserver" v-slot="{ handleSubmit }">
                  <form @submit.prevent="handleSubmit(submitLoginForm)">
                    <div class="mb-3">
                      <label class="required">Email</label>
                      <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                        <TextInput 
                          name="email"
                          autocomplete="email"
                          :value="login_form.email"
                          @input="handleLoginInput"
                          :error="errors[0]" 
                        />
                      </ValidationProvider>
                    </div>

                    <div class="mb-3">
                      <label class="required">Password</label>
                      <ValidationProvider name="password" rules="required" v-slot="{ errors }">
                        <TextInput 
                          type="password"
                          name="password"
                          autocomplete="new-password"
                          :value="login_form.password"
                          @input="handleLoginInput"
                          :error="errors[0]" 
                        />
                      </ValidationProvider>
                    </div>

                    <div class="d-flex justify-content-center">
                      <CButton
                        class="btn-secondary custom-button"
                        @click="goToLogin"
                      >
                        Back
                      </CButton>
                      <CButton
                        class="btn-primary custom-button ml-4"
                        type="submit"
                        :disabled="isLoading"
                      >
                        Login
                      </CButton>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
          </CCardBody>
          <CCardBody v-else-if="activeTab === 'register'">
            <ValidationObserver v-slot="{ handleSubmit }">
              <CRow class="text-center">
                <h5 class="text-primary ml-3">
                  Please create your user email ID
                </h5>
              </CRow>

              <CRow md="3" sm="12" class="text-left ml-1 mt-2">
                <label class="required">Enter Your Email</label>
              </CRow>

              <CRow md="6" sm="12" :class="{ 'py-4': isMobile }">
                <div class="col-12">
                  <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                    <TextInput
                      name="email"
                      :value="existingCandidate.email"
                      @input="handleExistingCandidateInput"
                      :error="errors[0]"
                      autocomplete="login-email"
                      ref="existingCandidate"
                      :disabled="isEmailDisabled"
                    />
                  </ValidationProvider>
                </div>
              </CRow>

              <CRow md="3" sm="12" class="text-left ml-1 mt-2">
                <label class="required">Confirm Your Email</label>
              </CRow>

              <CRow md="6" sm="12" :class="{ 'py-4': isMobile }">
                <div class="col-12">
                  <ValidationProvider
                    name="confirm_email"
                    rules="required|email|confirmedEmail:email"
                    v-slot="{ errors }"
                  >
                    <TextInput
                      name="confirm_email"
                      :value="existingCandidate.confirm_email"
                      @input="handleExistingCandidateInput"
                      :error="errors[0]"
                      :disabled="isEmailDisabled"
                    />
                  </ValidationProvider>
                </div>
              </CRow>

              <CRow class="mt-3">
                <CCol md="12" sm="12" class="center">
                  <CButton class="btn-secondary custom-button" @click="goToLogin">
                    Back
                  </CButton>
                  <CButton
                    name="registration-submit"
                    class="btn-primary ml-4 custom-button"
                    :disabled="isLoading"
                    @click="handleSubmit(checkCandidateExists)"
                  >
                    <CSpinner v-if="isLoading" class="spinner-border-sm text-white" />
                    <span v-else>Next</span>
                  </CButton>
                </CCol>
              </CRow>
            </ValidationObserver>
          </CCardBody>
        </CCard>
      </div>
      <div v-else-if="displayPage === 3 && !isCandidateSupplier">
        <CCard class="mt-2">
          <CCardBody>
            <CRow class="mb-3">
              <CCol
                md="3"
                sm="12"
                :class="isMobile ? 'center-align mb-3' : 'center-align'"
              >
                <CRow name="email-label" style="height: 100%">
                  <label
                    class="text-primary col-lg-12 col-md-12 mt-2"
                    style="font-weight: bold"
                    >Email ID</label
                  >
                </CRow>
              </CCol>
              <CCol md="6" sm="12">
                <CRow name="email" style="height: 100%">
                  <div class="col-12">
                    <TextInput
                      name="email"
                      :value="existingCandidate.email"
                      :disabled="true"
                    />
                  </div>
                </CRow>
              </CCol>
            </CRow>
            <CRow class="mt-3">
              <CCol md="2"></CCol>
              <CCol md="8" class="text-center">
                <p class="text-primary h6">You are already registered</p>
                <p v-if="getOrgName">
                  with <b>{{ getOrgName }}</b>
                </p>
                <p></p>
                <span class="text-primary h6">{{
                  getOrgVariant == Variant.campaign
                    ? "Please click below to new Sign Up"
                    : "Please click below to Sign In"
                }}</span>
              </CCol>
            </CRow>
            <CRow class="mt-3 center-align">
              <CCol md="5" class="center-align">
                <CButton class="btn-primary" @click="goToLogin">
                  {{
                    getOrgVariant == Variant.campaign ? "Sign Up" : "Sign In"
                  }}
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </div>
      <div v-else-if="displayPage === 4">
        <QuickRegistration
          :customer="customer"
          :organisationID="organisationID"
          :locationID="locationID"
          :profilePhoto="profilePhoto"
          :isSubmitted="isSubmitted"
          :existingCandidate="existingCandidate"
          :isCandidateSupplier="isCandidateSupplier"
          :campaignData="getCandidateData"
        />
      </div>
      <div
        v-else-if="displayPage === 5 && !isCandidateSupplier"
        class="d-flex justify-content-center align-items-center"
      >
        <CCard class="text-center shadow-lg" style="width: 600px">
          <CCardHeader 
            :class="isTFW ? 'bg-tfw-brand text-white h3 m-2 rounded' 
              :'bg-primary text-white h3 m-2 rounded'"
          >
            Already Registered !
          </CCardHeader>
          <CCardTitle class="h3 text-left ml-4 pt-3">
            Welcome Back
            <span class="text-primary h3">
              {{ getRegisteredMasterCandidateName | toTitleCase }}
            </span>
          </CCardTitle>
          <CCardBody class="px-5">
            <CRow name="email" class="mb-3" style="margin-left: -30px">
              <CCol :sm="4" class="text-left">
                <label
                  class="text-primary text-left pt-2"
                  style="font-weight: bold"
                  >Email ID / UserName</label
                >
              </CCol>
              <CCol :sm="8" class="mt-2">
                <div>
                  <TextInput
                    name="email"
                    :value="existingCandidate.email"
                    :disabled="true"
                  />
                </div>
              </CCol>
            </CRow>
            <CRow class="mb-3">
              <CCardText class="text-justify fs-6">
                <p>
                  TalentFind Marketplace is a global hub for health and social
                  care careers. You previously registered with
                  <b class="text-primary">
                    {{ getRegisteredMasterCustomerName }}
                  </b>
                  who is a member of the Marketplace which means you can use
                  that profile to complete your registration. Insert your
                  password and login to access your portal to verify your
                  profile.
                </p>
                <!-- <p v-if="showProfileContent === 1">
                  <b class="text-primary">{{ getOrgNameOrAcronym }}</b> is a member of the TalentFind Marketplace
                  network – the global healthcare careers hub.
                  You’re already registered and have a TalentFind profile.
                  <br/>
                  <a
                    href="#"
                    class="font-weight-bold text-primary"
                    @click="getMasterCustomer(getRegisteredMasterCustomerID, 2)">
                  click here
                   </a> 
                   to use this profile to quickly register with <b class="text-primary">{{ getOrgNameOrAcronym }}</b>.
                </p>

                <p v-if="showProfileContent !== 1">
                  <b class="text-primary">{{ getOrgNameOrAcronym }}</b> 
                  is a member of the TalentFind Marketplace network – the global healthcare careers hub.
                  You are already registered with 
                  <b class="text-primary">{{ getRegisteredMasterCustomerName }}</b> 
                  and have a TalentFind profile.
                  <br/>
                  <a
                    href="#"
                    class="font-weight-bold"
                    @click="getMasterCustomer(getRegisteredMasterCustomerID, 2)">
                  click here
                  </a> 
                  to use this profile to quickly register with <b class="text-primary">{{ getOrgNameOrAcronym }}</b> 
                </p> -->

                <CRow class="text-left">
                  <CCol md="12" class="font-weight-bold mb-2">
                    Please Enter your Password
                  </CCol>
                  <CCol>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      ref="existingCandidatePassword"
                    >
                      <TextInput
                        name="password"
                        type="password"
                        :value="userData.password"
                        @input="handleInput"
                        :error="errors[0]"
                      />
                    </ValidationProvider>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol class="text-left">
                    <CButton
                      @click="redirectToForgot"
                      color="link"
                      class="px-0 c-button-link"
                    >
                      Forgot password?
                    </CButton>
                  </CCol>
                </CRow>
              </CCardText>
              <!-- <RadioButton
                name="customer_id"
                :value="userData.code"
                @change="handleChangeRadio"
                class="radio-field font-weight-bold text-primary text-left"
                :vertically="true"
                :options="registeredOrgOpt || []"
              /> -->
            </CRow>
            <CRow class="d-flex justify-content-center">
              <CButton 
                class="btn-secondary custom-button mr-sm-3 mb-4"
                @click="goBack()"
              >
                Cancel
              </CButton>
              <CButton
                class="btn-primary custom-button mb-4"
                :disabled="isLoading"
                @click="onExistingCandidate()"
              >
                Login
              </CButton>
              <!-- <CButton class="btn-primary mr-3" @click="goToLogin()"
                >Home</CButton
              > -->
              <!-- <CButton
                class="btn-primary"
                @click="checkRadioField('customer_id')"
                >Next</CButton
              > -->
            </CRow>
          </CCardBody>
        </CCard>
      </div>
      <div
        v-else-if="displayPage === 6 && !isCandidateSupplier"
        class="d-flex justify-content-center align-items-center"
        style="height: 70vh"
      >
        <CCard style="width: 500px" class="shadow-lg">
          <CCardHeader 
            :class="isTFW ? 'bg-tfw-brand text-white h3 m-2 rounded' 
            :'bg-primary text-white h3 m-2 rounded'"
          >
            Password
          </CCardHeader>
          <CCardBody>
            <h3 class="mb-2">
              Welcome Back, 
              <span class="text-primary">
                {{
                  (isAlreadyRegistered
                    ? userInfo.candidate_name
                    : getRegisteredMasterCandidateName) | toTitleCase
                }}!
              </span>
            </h3>
            <CRow class="mb-3">
              <CCol md="12" class="font-weight-bold mb-2">
                Please Enter your Password
              </CCol>
              <CCol>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  ref="existingCandidatePassword"
                >
                  <TextInput
                    name="password"
                    type="password"
                    :value="userData.password"
                    @input="handleInput"
                    :error="errors[0]"
                  />
                </ValidationProvider>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="text-left">
                <CButton @click="redirectToForgot" color="link" class="px-0 c-button-link"
                  >Forgot password?</CButton
                >
              </CCol>
            </CRow>
            <CRow class="d-flex justify-content-center">
              <CButton class="btn-secondary mr-3 custom-button" @click="goBack()"
                >Back</CButton
              >
              <CButton
                v-if="!isAlreadyRegistered"
                class="btn-primary custom-button"
                :disabled="isLoading"
                @click="onExistingCandidate()"
                >Register</CButton
              >
              <CButton
                v-if="isAlreadyRegistered"
                class="btn-primary custom-button"
                :disabled="isLoading"
                @click="onLoginCandidate()"
                >Login</CButton
              >
            </CRow>
          </CCardBody>
        </CCard>
      </div>
      <div 
        v-if="displayPage === 7"
        class="container-fluid d-flex justify-content-center p-3"
      >
        <CCard class="shadow-lg w-100" style="max-width: 500px">
          <CCardHeader
            :class="isTFW ? 'bg-tfw-brand text-white h3 m-2 rounded' : 'bg-primary text-white h3 m-2 rounded'"
          >
            Start Your Journey
          </CCardHeader>

          <CCardBody>
            <ValidationObserver ref="basic_registration_observer" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(onSubmit)">
                <CRow>
                  <CCol md="12">
                    <div class="mb-3">
                      <label class="required">Email</label>
                      <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                        <TextInput 
                          name="email"
                          :disabled="true"
                          :value="basic_registration.email"
                          :error="errors[0]" 
                        />
                      </ValidationProvider>
                    </div>

                    <div class="mb-3">
                      <label class="required">Confirm Email</label>
                      <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                        <TextInput 
                          name="confirm_email"
                          :disabled="true"
                          :value="basic_registration.email"
                          :error="errors[0]" 
                        />
                      </ValidationProvider>
                    </div>

                    <div class="mb-3">
                      <label class="required">Title</label>
                      <ValidationProvider name="title" rules="required" v-slot="{ errors }">
                        <Select
                          name="title_id"
                          :options="titles"
                          :value="basic_registration.title_id"
                          @input="handleChangeSelect"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>

                    <div class="mb-3">
                      <label class="required">First Name</label>
                      <ValidationProvider name="first_name" rules="required" v-slot="{ errors }">
                        <TextInput 
                          name="first_name"
                          :value="basic_registration.first_name" 
                          @input="handleChangeInput"
                          :error="errors[0]" />
                      </ValidationProvider>
                    </div>

                    <div class="mb-3">
                      <label class="required">Last Name</label>
                      <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                        <TextInput 
                          name="surname"
                          v-model="basic_registration.surname" 
                          @input="handleChangeInput"
                          :error="errors[0]" 
                        />
                      </ValidationProvider>
                    </div>

                    <div class="mb-3">
                      <label class="required">Phone</label>
                      <ValidationProvider
                        ref="phone"
                        :rules="{
                          required: true,
                          phone_rule: /^\+\d{1,3}\^\d{1,15}$/,
                        }"
                        v-slot="{ errors }"
                      >
                        <PhoneInputwithCountry
                          name="phone"
                          :value="basic_registration.phone"
                          :options="dialingCodeWithCountryCode || []"
                          @change="handleChangeInput"
                          :error="errors[0]"
                          ref="phoneNo"
                        />
                      </ValidationProvider>
                    </div>

                    <div class="mb-4">
                      <label class="required">Profession</label>
                      <ValidationProvider name="candidate_type_id" rules="required" v-slot="{ errors }">
                        <Select
                          name="candidate_type_id"
                          :options="candidateType"
                          :value="basic_registration.candidate_type_id"
                          @input="handleChangeSelect"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>

                    <div class="mb-4">
                      <label class="required">Specialty/Expertise</label>
                      <ValidationProvider name="specialty" rules="required" v-slot="{ errors }">
                        <Select
                          name="speciality_id"
                          :options="isNurse ? getNurseSubSpecialty : specialties || []"
                          :value="basic_registration.speciality_id"
                          @input="handleChangeSelect"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>

                    <div class="mb-4">
                      <label class="required">Password</label>
                      <ValidationProvider name="password" 
                      :rules="{
                        required: true,
                        password_length: 8,
                        password_strength: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                      }"
                      v-slot="{ errors }">
                         <PasswordInput
                          name="password"
                          :value="basic_registration.password"
                          @input="handleChangeInput"
                          :error="errors[0]"
                          autocomplete="new-password"
                        />
                      </ValidationProvider>
                    </div>

                    <div class="mb-4">
                      <label class="required">Confirm Password</label>
                      <ValidationProvider                     
                      rules="required|confirmed:password"
                      v-slot="{ errors }">
                         <PasswordInput
                          name="confirmPassword"
                          :value="basic_registration.confirmPassword"
                          @input="handleChangeInput"
                          :error="errors[0]"
                          autocomplete="new-password"
                        />
                      </ValidationProvider>
                    </div>

                    <div class="mb-4">
                      <label class="required">What Is Your Highest Level of Education or Training?</label>
                      <ValidationProvider name="is_student" rules="required" v-slot="{ errors }">
                        <RadioButton
                          name="is_student"
                          :value="basic_registration.is_student"
                          :options="educationOptions"
                          @change="handleChangeSelect"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CCol>
                </CRow>
                <div class="d-flex justify-content-center">
                  <CButton
                    class="btn-secondary custom-button mr-3"
                    @click="goToLogin"
                  >
                    Cancel
                  </CButton>
                  <CButton
                    class="btn-primary custom-button"
                    type="submit"
                    :disabled="isLoading"
                  >
                    Register
                  </CButton>
                </div>
              </form>
            </ValidationObserver>
          </CCardBody>
        </CCard>
      </div>
    </div>
    <!-- Short Registration Modal -->
    <CustomModal
      :isShowPopup="basicRegistrationModal.isShowPopup"
      :closeOnBackdropClick="false"
      theme="default"
      size="lg"
    >
      <template v-slot:body>
        <div class="container">
          <div class="card border-0 text-center">
            <h1 class="text-primary font-weight-bold mb-3">
              Welcome, {{ basic_registration.first_name | toTitleCase }}
            </h1>

            <p class="lead mb-3">
              Start Your Journey with Us Today!
            </p>

            <p class="font-weight-bold">Complete your profile to unlock a world of
              opportunities:</p>

            <ul class="text-left mx-auto" style="max-width: 600px;">
              <li class="mb-2">
                Access Your Personalised Portal.
              </li>
              <li class="mb-2">
                Manage and update your profile, preferences, CV, and documentation.
              </li>
              <li class="mb-2">
                Explore accredited training.
              </li>
              <li class="mb-2">
                View and apply for the latest job openings tailored to your profile.
              </li>
              <li class="mb-2">
                Receive notifications, updates, and feedback in one place.
              </li>
              <li class="mb-2">
                Maintain an optional private or public profile.
              </li>
              <li class="mb-3">
                Access the TalentFind Marketplace.
              </li>
              <p class="font-weight-bold">with more to come...</p>
            </ul>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <CButton class="btn-primary custom-button mr-5" @click="registerLater()">
          I'LL FINISH IT LATER
        </CButton>
        <CButton class="btn-primary custom-button" @click="completeRegistration()">
          COMPLETE PROFILE
        </CButton>
      </template>
    </CustomModal>

    <!-- Password Modal -->
    <CustomModal
      :isShowPopup="passwordModal.isShowPopup"
      :closeOnBackdropClick="false"
      theme="default"
      size="md"
    >
      <template v-slot:body>
        <form @submit.prevent="registerWithPassword">
          <div class="container">
            <div class="card border-0">
              <h1 class="text-primary font-weight-bold mb-3">
                Welcome, {{ (basic_registration.first_name || getExistUserCandidate.first_name) | toTitleCase }}
              </h1>

              <label class="required">Enter Password</label>
              <ValidationProvider name="password" rules="required" v-slot="{ errors }">
                <PasswordInput 
                  name="password"
                  :value="passwordModal.data.password"
                  @input="handlePasswordInput"
                  autocomplete="new-password"
                  :error="errors[0]"
                />
              </ValidationProvider>
            </div>
          </div>

          <CCol class="text-left">
            <CButton @click="redirectToForgot" color="link" class="px-0 c-button-link"> 
              Forgot password?
            </CButton>
          </CCol>

          <button type="submit" class="d-none"></button>
        </form>
      </template>

      <template v-slot:footer>
        <CButton class="btn-secondary custom-button" @click="goBack()">
          Cancel
        </CButton>
        <CButton class="btn-primary custom-button" type="submit" @click="registerWithPassword()">
          Register Now
        </CButton>
      </template>
    </CustomModal>

    <!-- Complete Profile Modal(only full_registration=false)-->
    <CustomModal
      :isShowPopup="showCompleteProfileModal"
      :closeOnBackdropClick="false"
      theme="default"
      size="lg"
    >
      <template v-slot:body>
        <div class="container">
          <div class="card border-0">
            <h3 class="text-primary font-weight-bold mb-3  text-center">
              Welcome to {{ getOrgNameFromGetUser }} - Your Journey Starts Here!
            </h3>

            <h4 class="text-primary text-left font-weight-bold mb-3">
              Hello, {{ getExistUserCandidate.first_name | toTitleCase }}
            </h4>

            <p class="lead mb-3 text-center">
              Complete Your Profile and unlock career options!
            </p>

            <p class="font-weight-bold text-left">
              Why complete your profile?
            </p>

            <ul class="text-left list-unstyled ml-3">
              <li class="mb-2">
                <i class="fa-solid fa-check"></i>&nbsp;&nbsp;Build your digital passport in one secure platform 
              </li>
              <li class="mb-2">
                <i class="fa-solid fa-check"></i>&nbsp;&nbsp;Store documents in your personal wallet
              </li>
              <li class="mb-2">
                <i class="fa-solid fa-check"></i>&nbsp;&nbsp;Access career opportunities with structured pathways
              </li>
              <li class="mb-2">
                <i class="fa-solid fa-check"></i>&nbsp;&nbsp;Get personalized insights and recommendations 
              </li>
              <li class="mb-2">
                <i class="fa-solid fa-check"></i>&nbsp;&nbsp;Connect in a trusted global healthcare ecosystem
              </li>
            </ul>
          </div>

          <div>
            <p class="font-weight-bold">Prefer to just connect?</p>
            <p>
              You can still be part of our community! Complete your
              profile and set it to Private to stay engaged your way.
            </p>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <CButton class="btn-primary custom-button mr-5" @click="exitCompleteProfile()">
          I'll Finish Later
        </CButton>
        <CButton class="btn-primary custom-button" @click="completeProfile()">
          <i class="fa-solid fa-hand-point-right"></i>&nbsp;&nbsp;Complete My Profile Now
        </CButton>
      </template>
    </CustomModal>
  </div>
</template>

<script>
import Vue from "vue";
import m from "moment";
import { extend } from "vee-validate";
import {
  required,
  email,
  confirmed,
  regex,
  min,
  numeric,
  alpha_spaces,
} from "vee-validate/dist/rules";
import { mapGetters, mapActions } from "vuex";
import QuickRegistration from "@/containers/CandidateProfile/Registration/QuickRegistration";
import Modal from "@/components/reusable/Modal";

extend("required", { ...required, message: "This field is required" });
extend("password_length", {
  validate: value => {
    if (typeof value !== "string") return false;
    return value.length >= 8;
  },
  message: "Password must be at least 8 characters",
});
extend("password_strength", {
  ...regex,
  message: "Password must have capitals, numbers and special characters",
})
extend("confirmed", {
  ...confirmed,
  message: "This field should match password",
});
extend("confirmedEmail", {
  ...confirmed,
  message: "Email & Confirm Email should be same",
});
extend("confirmedPassword", {
  ...confirmed,
  message: "Password and confirm password should be same",
});
extend("email", { ...email, message: "Invalid email" });
extend("numeric", { ...numeric, message: "Only numbers are allowed" });
extend("phone_rule", {
  ...regex,
  message: "Only numbers are allowed(Maximum of 15 digits)",
});
extend("date_validate", (value) => {
  if (m(value).isValid()) {
    return true;
  }
  return "Invalid date! Enter a valid date";
});
extend("alpha_spaces", {
  ...alpha_spaces,
  message: "Only Alphabets are allowed",
});
extend("no_future_date", (value) => {
  let input_date = new Date(value);
  let today_date = new Date();
  if (input_date > today_date) {
    return "Given date should not be greater than today!";
  }
  return true;
});
extend("dob_check", {
  params: ["dob"],
  validate(value, { dob }) {
    let birth_date = new Date(dob);
    let input_date = new Date(value);
    if (!(input_date < birth_date)) {
      return true;
    }
  },
  message: "Given date should be between birthdate & today!",
});
extend("higher_qual_date_check", {
  params: ["first_qualified_date"],
  validate(value, { first_qualified_date }) {
    let first_qual_date = new Date(first_qualified_date);
    let input_date = new Date(value);
    if (!(input_date < first_qual_date)) {
      return true;
    }
  },
  message: "Given date should be greater than first qualification date!",
});

extend("emailConfirmed", { ...confirmed, message: "The email addresses entered do not match. Please correct and try again." });

import TextInput from "@/components/reusable/Fields/TextInput";
import { LOGIN_URL, getLocalOrgDetail, Variant, CONSTANT as CONST, getRoleScopes } from "@/helpers/helper";
import PasswordInput from "@/components/reusable/Fields/PasswordInput";
import RadioButton from "@/components/reusable/Fields/RadioButton";
import { BASE_URL } from "@/service_urls";
import _ from "lodash";
import Select from "@/components/reusable/Fields/Select";
import PhoneInput from "@/components/reusable/Fields/PhoneInput";
import CustomModal from "../../components/reusable/CustomModal.vue";
import PhoneInputwithCountry from "@/components/reusable/Fields/PhoneInputwithCountry";


export default {
  components: {
    TextInput,
    PasswordInput,
    QuickRegistration,
    Modal,
    RadioButton,
    Select,
    PhoneInput,
    CustomModal,
    PhoneInputwithCountry
  },
  props: {
    customer: {
      type: Number,
      default: null,
    },
    isCandidateSupplier: {
      type: Boolean,
      default: false,
    },
    organisationID: {
      type: Number,
    },
    locationID: {
      type: Number,
    },
    profilePhoto: {},
    isSubmitted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Variant,
      isMobile: false,
      showDeactivatedModal: false,
      existingCandidate: {},
      displayPage: this.isCandidateSupplier ? 4 : 1,
      isLoading: false,
      emailConfirmModal: {
        modalColor: "primary",
        modalTitle: "NOTIFICATION",
        modalContent: "Please verify that the provided email ID is correct.",
        isShowPopup: false,
        buttons: ["Cancel", "Confirm"],
        showCloseButton: false,
      },
      isEmailDisabled: this.campaignFieldsData ? true : false,
      userData: {},
      registeredOrg: [],
      candidate: {},
      isAlreadyRegistered: false,
      userInfo: {},
      basic_registration: {},
      basic_registration_payload: {},
      basicRegistrationModal: {
        isShowPopup: false,
      },
      activeTab: "register",
      login_form: {
        email: "",
        password: ""
      },
      existUserCandidate: {},
      passwordModal:{
        isShowPopup: false,
        data: {
          password: ""
        }
      },
    };
  },
  computed: {
    ...mapGetters([
      "orgDeactivated",
      "getOrgDetail",
      "getRegisteredParent",
      "getOrgVariant",
      "campaignFieldsData",
      "getCampaignById",
      "fromCampaignPage",
      "getRegistrationStep",
      "registerCandidateData",
      "getCampaignCandidateDetails",
      "titles",
      "candidateType",
      "dialingCodeWithCountryCode",
      "getCandidateData",
      "getPathAcronymByOrgDetail",
      "specialityByTypeAndCountry",
      "getNurseSubSpeciality",
      "getExistUserCandidate",
      "getCurrentDisplayPage",
      "showCompleteProfileModal",
      "getUser",
      "isSuperCustomer",
      "isLoggedIn",
    ]),

    getOrgName() {
      return this.getOrgDetail?.name;
    },
    hospitalName() {
      return getLocalOrgDetail()?.name ? getLocalOrgDetail()?.name : "";
    },
    isParent() {
      return getLocalOrgDetail()?.is_parent || false;
    },
    getScreenSize() {
      return {
        width: screen.availWidth,
        height: screen.availHeight,
      };
    },
    getBackgroundImage() {
      return `${BASE_URL}${this.getCampaignById?.uuid_background_image_link_to_doc?.replace(
        "/api/v1",
        ""
      )}?file=background_image&${new Date().getTime()}`;
    },
    isTFW() {
      return this.$route.params.org_name === "tfm";
    },
    registeredMasterOrg() {
      return (Array.isArray(this.registeredOrg) ? this.registeredOrg : []).filter(v => v?.is_master);
    },
    registeredOrgOpt() {
      const static_opt = {
        code: 0,
        label: `I want to create a new profile in ${this.getPathAcronym.toUpperCase()}`,
      };
      return [
        ...(this.registeredMasterOrg?.map((v) => ({
          code: v?.customer_uid,
          label: `Share this Profile : ${v?.candidate_name} - ${v?.candidate_type} - ${v?.customer_name}`,
          rawData: v,
        })) || []),
        static_opt,
      ];
    },
    selectedCustomerOrg() {
      return this.userData?.customer_id?.label || null;
    },
    getCustomerID() {
      return getLocalOrgDetail()?.customer_uid || null;
    },
    getOrgID() {
      return getLocalOrgDetail()?.organisation_id || null;
    },
    getLocationID() {
      return getLocalOrgDetail()?.location_id || null;
    },
    getRegisteredMasterCustomerName() {
      return (
        this.registeredMasterOrg?.[0]?.customer_name ||
        this.getExistUserCandidate?.customer_organisation_candidates.find(
          (v) => v.is_master === true
        )?.customer_name ||
        ""
      );
    },
    routeToCandidateJobList() {
      this.$router.push("/jobs-list");
    },
    getPathAcronym() {
      let { path_acronym } = getLocalOrgDetail();
      return path_acronym;
    },
    getRegisteredMasterCustomerID() {
      return this.registeredMasterOrg[0].customer_uid || "";
    },
    getRegisteredMasterCandidateName() {
      return this.registeredMasterOrg?.[0]?.candidate_name || this.getExistUserCandidate?.first_name || "";
    },
    showProfileContent() {
      return this.registeredMasterOrg?.[0].customer_type_id || "";
    },
    getOrgNameOrAcronym() {
      return this.getOrgName
        ? this.getOrgName
        : this.getPathAcronym.toUpperCase();
    },
    isPartnerAgency() {
      return (
        this.getOrgDetail?.organisation_type_id ===
          CONST.ORG_TYPES.partner_agency || false
      );
    },
    specialties() {
      let specialties = this.specialityByTypeAndCountry({
        candidateType: this.basic_registration.candidate_type_id?.code
      }) || [];
      return specialties
    },
    educationOptions() {
      return [
        { code: true, label: "Below Degree Level, Currently Studying, or No Formal Qualifications" },
        { code: false, label: "Degree Level or Higher" },
      ];
    },
    getNurseSubSpecialty() {
      return this.getNurseSubSpeciality || []
    },
    isNurse() {
      return this.basic_registration.candidate_type_id?.code === 2;
    },
    getOrgNameFromGetUser() {
      if(this.isSuperCustomer) {
        return "TalentFind"
      } else {
        return this.getUser?.org_detail?.org_name || "TalentFind"
      }
    },
  },
  watch: {
    isCandidateSupplier() {
      this.displayPage = 4;
    },
    '$route.query.check_email'(newVal) {
      if(this.getCurrentDisplayPage == 4) {
        return;
      }
      this.handleCheckEmailFromQuery();
    },
    '$route.query.tt'(newVal) {
      this.checkCandidateExists();
    },
  },
  async mounted() {
    this.getTitles();
    this.fetchCandidateType();
    this.locationCountryInfo();
    this.speciality();
    this.fetchNurseSubSpeciality();

    this.scrollTop();
    let isMobile = window.matchMedia(
      "only screen and (max-width: 400px)"
    ).matches;
    this.isMobile = isMobile;

    // Check Email
    let check_email = (this.$route.query?.check_email || "").trim();
    check_email = decodeURIComponent(check_email).replace(/\s/g, "+");

    if (check_email) {
      this.handleExistingCandidateInput("email", check_email);
      this.handleExistingCandidateInput("confirm_email", check_email);

      if(this.getCurrentDisplayPage == 4) {
        this.displayPage = this.getCurrentDisplayPage;
        return;
      }

      this.displayPage = 0;
      this.$nextTick(() => {
        this.checkCandidateExists();
      });
    } else if (
      this.getCampaignCandidateDetails &&
      this.getCampaignCandidateDetails?.email
    ) {
      const email = this.getCampaignCandidateDetails?.email;
      this.existingCandidate = {
        email,
        confirm_email: email,
      };
      this.checkCandidateExists();
    }
    this.registeredOrg = this.registerCandidateData;
    if (this.registeredOrg && this.registeredOrg.length) {
      this.existingCandidate.email = this.registeredOrg[0]?.email;
      this.displayPage = this.getRegistrationStep;
    }
  },
  methods: {
    ...mapActions([
      "scrollTop",
      "showToast",
      "getRegisteredHospitalsByEmail",
      "registerCommonCandidate",
      "resetCandidate",
      "clearCampaignFieldsData",
      "getCampaignsByEmail",
      "getCampaignsDataByCampaignUserID",
      "checkCandidateInTFW",
      "login",
      "isEmailBelongsToAcronym",
      "showLoader",
      "hideLoader",
      "checkCandidateExistInCampaign",
      "getTitles",
      "fetchCandidateType",
      "locationCountryInfo",
      "campaignRegistration",
      "campaignRegisterLater",
      "speciality",
      "fetchNurseSubSpeciality",
      "createShortRegistration",
      "loginBeforeRegistration",
      "logout",
    ]),
    switchToPrimaryOrgLogin() {
      const acronym = this.orgDeactivated?.primary_path_acronym;
      if (acronym) {
        this.showDeactivatedModal = false;
        this.$store.commit("SET_ORG_DEACTIVATED", null);
        window.location.href = `/${acronym}`;
      }
    },
    goToLogin() {
      if (this.getOrgVariant == Variant.campaign) {
        this.resetCandidate();
        let { path_acronym, customer_uid, organisation_id, location_id } =
          getLocalOrgDetail();

        let path = `/${path_acronym}/register/${customer_uid}`;
        if (organisation_id)
          path += `/organisation/${organisation_id}/location/${location_id}`;

        this.$router.push({ path: path });
        this.displayPage = 1;
        this.resetForm();
      } else {
        this.$router.push({ path: LOGIN_URL() });
      }
    },

    resetForm() {
      let email = this.existingCandidate["email"];
      this.existingCandidate = { email };
    },
    handleExistingCandidateInput(name, value) {
      let val = value;
      if (name === "email" || name === "confirm_email") {
        val = value?.toLowerCase().trim();
      }
      Vue.set(this.existingCandidate, name, val);
    },
    async onExistingCandidate() {
      this.$refs.existingCandidatePassword.validate();
      const isPasswordEntered = this.userData?.password;

      if (isPasswordEntered) {
        try {
          let payload = {
            email: this.existingCandidate?.email,
            customer_uid: this.customer,
            organisation_id: this.organisationID ? this.organisationID : null,
            location_id: this.locationID ? this.locationID : null,
            password: isPasswordEntered,
          };

          await this.registerCommonCandidate(payload);

          const data = {
            username: this.existingCandidate?.email,
            password: isPasswordEntered,
          };

          await this.login(data);
        } catch (error) {
          console.error("An error occurred:", error);
        }
      }
    },
    checkCandidateExists() {
      this.isLoading = true;
      if (!this.existingCandidate["email"]) {
        this.showToast({
          class: "bg-danger text-white",
          message: "Enter valid email!",
        });
        this.isLoading = false;
        return false;
      }
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(String(this.existingCandidate["email"]).toLowerCase())) {
        this.showToast({
          class: "bg-danger text-white",
          message: "Enter valid email!",
        });
        this.isLoading = false;
        return false;
      }
      if (
        this.existingCandidate["email"] ===
        this.existingCandidate["confirm_email"]
      ) {
        const payload = {
          email: this.existingCandidate["email"],
          customer_uid: this.customer,
          organisation_uid: this.organisationID || null,
          check_registered: true,
        };
        this.getRegisteredHospitalsByEmail(payload).then((res) => {
          this.basic_registration.email = this.existingCandidate["email"];

          if(res?.data?.full_registration === false) {
            const data = res.data;
            this.$store.commit("SET_EXIST_USER_CANDIDATE", data);

            this.isLoading = false;
            if(this.getCurrentDisplayPage === 4) {
              return;
            }

            const candidate_registered_org_ids = data?.customer_organisation_candidates?.map(
              (v) => v.organisation_id
            ) || [];

            if (
              candidate_registered_org_ids.length > 0 &&
              candidate_registered_org_ids.includes(this.organisationID)
            ) {
              if(getRoleScopes().includes('customer_candidate') || getRoleScopes().includes('system_candidate')) {
                this.displayPage = 4;
                return;
              }
              this.passwordModal.isShowPopup = true;
            } else {
              // Profile share page
              this.displayPage = 5;
            }
            return;
          }

          this.isLoading = false;

          if (res?.response?.data?.detail?.org_deactivated) {
            return;
          }

          const errMsg =
            res?.response?.data?.detail?.message || res?.response?.data?.detail;
          if (res?.response?.status === 409) {
            let message = errMsg;
            this.showToast({
              class: "bg-danger text-white",
              message,
            });
            this.$router.push({ path: LOGIN_URL() })
          } else if (
            res?.response?.status === 400 &&
            errMsg?.includes("Already registered")
          ) {
            this.userInfo = {
              candidate_name: res?.response?.data?.detail?.candidate_name,
            };
            this.isAlreadyRegistered = true;
            this.displayPage = 6;
          } else if (!res?.data) {
            // check if the candidate registered in campaign
            const payload = {
              email: this.existingCandidate["email"],
            };
            this.checkCandidateExistInCampaign(payload).then((res) => {
              if(!res && !this.isTFW && !this.isPartnerAgency) {
                // Short Registration screen
                this.displayPage = 7
                return;
              }
              this.displayPage = 4;
              // this.$router.push({
              //   query: {
              //     ...this.$route.query,
              //     welcome_modal: true
              //   }
              // });
            });
          } else {
            this.registeredOrg = res?.data;
            if(this.registeredOrg.length > 0  && !this.registeredOrg[0]?.full_registration) {
              this.displayPage = 4;
            } else {
              this.displayPage = 5;
            }
          }
        });
      } else {
        // this.showToast({
        //   class: "bg-danger text-white",
        //   message: "The email addresses entered do not match. Please correct and try again.",
        // });
        this.isLoading = false;
        return false;
      }
    },
    checkCandidateRegisteredInCampaign(payload) {
      /**
       * check if the candidate registered in campaign
       */
      if (!payload.organisation_uid) delete payload.organisation_uid;
      this.getCampaignsByEmail(payload).then((res) => {
        // fetch more details
        if (res) {
          this.getCampaignsDataByCampaignUserID({
            campaign_user_id: res?.campaign_user_id,
            campaign_id: res?.campaign_id,
          }).then(() => {
            this.displayPage = 4;
          });
        } else {
          this.displayPage = 4;
        }
      });
    },
    handleChangeRadio(name, value) {
      Vue.set(this.userData, name, value);
    },
    handleInput(name, value) {
      Vue.set(this.userData, name, value);
    },
    handleChangeInput(name, value) {
      Vue.set(this.basic_registration, name, value);
      Vue.set(this.basic_registration_payload, name, value);
      if(name === "phone") {
        
      }
    },
    handleChangeSelect(name, value) {
      Vue.set(this.basic_registration, name, value);
      if(name === "speciality_id") {
        Vue.set(this.basic_registration_payload, name, value.code);
        Vue.set(this.basic_registration_payload, "sub_speciality_id", value.sub_speciality_id);
      } else {
        Vue.set(this.basic_registration_payload, name, value.code);
      }
    },
    checkRadioField(field) {
      if (this.userData[field] != undefined && this.userData) {
        if (field === "customer_id" && this.userData[field]?.code === 0) {
          this.existingCandidate.email = "";
          this.displayPage = 1;
          return;
        }
        this.displayPage = 6;
        return;
      }
      this.showToast({
        class: "bg-danger text-white",
        message: "Please choose your base customer!",
      });
    },
    getMasterCustomer(customer_id, display_page) {
      this.userData.customer_id = customer_id;
      this.checkRadioField("customer_id", display_page);
    },
    redirectToForgot() {
      this.$router.push({
        path: `/${this.getPathAcronymByOrgDetail}/forgot`,
      });
    },
    onLoginCandidate() {
      const password = this.userData?.password;
      if (!password) {
        this.showToast({
          class: "bg-danger text-white",
          message: "Enter password!",
        });
        return false;
      }
      const data = {
        username: this.existingCandidate?.email,
        password: this.userData?.password,
      };
      this.login(data);
    },
    goBack() {
      this.existingCandidate = {};
      this.$router.push(LOGIN_URL());
    },
    async onSubmit() {
      this.isLoading = true;
      const isValid = await this.$refs.basic_registration_observer.validate();
      if (!isValid) {
        this.showToast({
          class: "bg-danger text-white",
          message: "Please fill mandatory fields!",
        });
        this.isLoading = false;
        return;
      }
      
      this.basic_registration_payload = {
        ...this.basic_registration_payload,
        email: this.basic_registration.email.trim().toLowerCase(),
      }
      
      await this.createShortRegistration(this.basic_registration_payload)
        .then((res) => {
          if (res?.user_id) {
            this.basicRegistrationModal.isShowPopup = true;
          }
        })

      this.isLoading = false;
    },
    async registerLater() {
      await this.campaignRegisterLater({
        email: this.basic_registration.email,
        campaign_name: this.basic_registration.campaign_name,
      });
      this.basicRegistrationModal.isShowPopup = false;
      this.goToLogin();

    },
    async completeRegistration() {
      this.basicRegistrationModal.isShowPopup = false;
      
      const payload = {
        email: this.basic_registration.email,
      }
      const getRegisteredHospitalsByEmailPayload = {
        email: this.basic_registration.email,
        customer_uid: this.getCustomerID,
        organisation_uid: this.getOrgID
      }
      await this.checkCandidateExistInCampaign(payload);

      // Check Candidate exist in User and Candidate table
      const exist_user_candidate = await this.getRegisteredHospitalsByEmail(getRegisteredHospitalsByEmailPayload);
      if(exist_user_candidate?.data?.full_registration === false) {
        this.$store.commit("SET_EXIST_USER_CANDIDATE", exist_user_candidate?.data);
        
        const login_data = {
          username: this.basic_registration.email,
          password: this.basic_registration.password,
          is_registration_page: true,
        }

        if(login_data?.username && login_data?.password) {
          await this.loginForRegistration(login_data);
        }
      }
    },
    async loginForRegistration(data) {
      await this.login({
        username: data.username,
        password: data.password,
        is_registration_page: data.is_registration_page
      }).then((res) => {
        if(res.status === 200) {
          this.displayPage = 4;
        }
      });
    },
    async registerWithPassword() {
      const login_data = {
        username: this.basic_registration.email,
        password: this.passwordModal.data.password
      }

      if(login_data?.username && login_data?.password) {
        this.passwordModal.isShowPopup = false;
        await this.loginForRegistration(login_data);
      }
    },
    handleLoginInput(name, value) {
      Vue.set(this.login_form, name, value);
    },
    handleCheckEmailFromQuery() {
      let check_email = (this.$route.query?.check_email || "").trim();
      check_email = decodeURIComponent(check_email).replace(/\s/g, "+");
      if (check_email) {
        this.displayPage = 0;
        this.handleExistingCandidateInput("email", check_email);
        this.handleExistingCandidateInput("confirm_email", check_email);
        this.$nextTick(() => {
          this.checkCandidateExists();
        });
      }
    },
    async submitLoginForm() {
      try {
        const isValid = await this.$refs.loginObserver.validate();
        if (!isValid) {
          return;
        }

        this.isLoading = true;

        const data = {
          username: this.login_form?.email,
          password: this.login_form?.password,
        };

        const getRegisteredHospitalsByEmailPayload = {
          email: this.login_form?.email,
          customer_uid: this.getCustomerID,
          organisation_uid: this.getOrgID
        }

        await this.isEmailBelongsToAcronym(data)
        .then(async (res) => {
            if (res?.status === 200) {
              const exist_user_candidate = await this.getRegisteredHospitalsByEmail(getRegisteredHospitalsByEmailPayload);
              this.$store.commit("SET_EXIST_USER_CANDIDATE", exist_user_candidate?.data);
              await this.$nextTick();
              await this.login(data);
            }
          })
      } catch (error) {
        console.error("Login error:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handlePasswordInput(name, value) {
      Vue.set(this.passwordModal.data, name, value);
    },
    completeProfile() {
      this.displayPage = 4;
      this.$store.commit("SET_SHOW_COMPLETE_PROFILE_MODAL", false);
    },
    async exitCompleteProfile() {
      this.$store.commit("SET_SHOW_COMPLETE_PROFILE_MODAL", false)
      await this.logout();
    }
  },
  beforeDestroy() {
    this.$store.commit("CLEAR_CANDIDATE_DATA");
  },
  filters: {
    toTitleCase(data) {
      return data ? _.startCase(data) : data;
    },
  },
  watch: {
    isLoggedIn() {
      if(this.isLoggedIn && this.displayPage === 1) {
        this.displayPage = 4;
      }
    },
    orgDeactivated(val) {
      this.showDeactivatedModal = !!(val);
    },
  }
};
</script>

<style lang="scss" scoped>
.hint {
  opacity: 0.7;
}
.img-width {
  width: 100%;
}
@media all and (max-width: 375px) {
  .text-center > .btn {
    width: 145px;
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
}
.action-button {
  width: 14px;
  height: 14px;
  border: 0;
  background: transparent;
  padding: 0;
  outline: none;
}
.registered-whatsapp {
  padding-top: 5px;
}
@media all and (max-width: 480px) {
  .registered-whatsapp {
    padding-top: 0%;
  }
}
.center-align {
  display: flex;
  justify-content: center;
  align-items: center;
}
#hospital-list {
  padding-left: 0.5rem;
}
.cursor-action {
  cursor: pointer;
}
.cursor-action:hover {
  text-decoration: underline;
}
.fs-12 {
  font-size: 12px;
}
.campaign-register {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.campaign-register::-webkit-scrollbar {
  width: 0; /* hide scrollbar in Chrome, Safari, and Opera */
}
.campaign-image {
  margin-top: -22px;
  margin-right: -30px;
  margin-left: -30px;
}
@media (max-width: 1084px) {
  #bg-img {
    display: none;
  }
}
.istfw {
  padding-top: 22px;
}


.c-button-link:hover {
  color: #0d6efd !important;
}

.custom-tabs {
  background-color: #f8f9fa;
  border-radius: 0.5rem;
  overflow: hidden;
  border: 1px solid var(--primary);
}
.custom-tab {
  padding: 0.7rem;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  border-radius: 0;
}

.custom-tab.active {
  background-color: var(--primary);
  color: white !important;
  font-weight: 600;
}

@media (min-width: 1024px) {
  .custom-container {
    width: 60%;
  }
}
.deact-banner {
  background: #fff0f0;
  border-left: 4px solid #e55353;
  border-radius: 4px;
  padding: 10px 14px;
  font-size: 0.875rem;
  color: #c0392b;
  font-weight: 600;
}
.deact-primary-box {
  background: #f0f7ff;
  border-left: 4px solid #321fdb;
  border-radius: 4px;
  padding: 10px 14px;
  font-size: 0.875rem;
  color: #2c3e50;
}
.deact-support-box {
  background: #fff8e1;
  border-left: 4px solid #ffc107;
  border-radius: 4px;
  padding: 10px 14px;
  font-size: 0.82rem;
  color: #856404;
}
</style>
